import React, { useEffect, useRef } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'

import Header from './Header'
import Sidebar from './Sidebar'

import MainPage from './Main'
import NotePage from './Note'
import CustomerPage from './Customer'
import SettingPage from './Setting'
import InsurancePage from './Insurance'

import './layout.css'

import { setRefreshToken, getRefreshToken } from '../utils/localStorageUtil'
import useAccountStore from '../stores/account'
import axios from 'axios'
import { BASEURL } from '../config'
import useAppStatusStore from '../stores/appStatus'
import LoginPage from './Login'
import IntroducePage from './Introduce'
import useEstimateStore from '../stores/estimate'

const initJWT = async() => {
    // refreshToken이 있으면 accessToken 갱신, 없으면 로그인 페이지로 리다이렉트 (임시로 임시로그인 함수 사용)
    const refreshToken = getRefreshToken()
    if (refreshToken){
      // refreshToken이 있으면 accessToken 갱신
      axios.post(`${BASEURL}/auth/token`, { refreshToken }).then(response => response.data)
        .then(obj => {
          // obj {status, data, message}
          if(obj.status === "success") { useAccountStore.getState().setAccessToken(obj.data.accessToken) }
          else { throw new Error(obj.message) }
        })
        .catch(error => {
          // AccessToken 갱신 실패 - 로그인 페이지로 리다이렉트 등의 처리
          useAccountStore.getState().setAccessToken('')
          setRefreshToken('')
        })
    }
}
const initFirebaseToken = async() => {
    // initFirebaseToken : 페이지 로드 시 Firebase 토큰 가져오는 함수
    // TODO : Firebase 토큰 가져오는 로직 추가
}

const initToken = async() => {
    // initToken : 페이지 로드 시 JWT, Firebase 토큰 가져오는 함수
    await initJWT()
    await initFirebaseToken()
}

const RouterPage = (props:any) => {
    const { accessToken } = useAccountStore()
    const {isLoading} = useAppStatusStore()
    const { estimateList, setEstimateList } = useEstimateStore()
    const intervalRef = useRef<number | undefined>(undefined)
    const getDataIntervalRef = useRef<number | undefined>(undefined)

    const InitIntervalTime = 720000 // 12분
    const getDataIntervalTime = 7000 // 7초

    const curLocation = useLocation()
    const protectedRoutes = ['/main', '/note', '/customer', '/setting', '/insurance']
    const isProtectedRoute = protectedRoutes.some(route => curLocation.pathname.startsWith(route))

    const getEstiData = async() => {
        if(!accessToken) return
        
        await axios.get(`${BASEURL}/esti/list`, { headers: {Authorization: `Bearer ${accessToken}`, }})
        .then(response => response.data)
        .then(obj => {
            if(obj.status === "success") {
                // TODO : 깊은 비교로 변경사항 확인
                const isChanged = (prev:any) => JSON.stringify(prev) === JSON.stringify(obj.data) ? false : true

                if(isChanged(estimateList)) { setEstimateList(obj.data) }
            }
        }).catch(error => {
            setEstimateList([])

            if(error.response) {
                // temp error handling
                if(error.response.status === 401) console.log("토큰이 만료되었습니다.")
                if(error.response.status === 403) console.log("토큰이 유효하지 않습니다.")
                if(error.response.status === 404) console.log("사용자 정보를 찾을 수 없습니다.")
            }
            else { console.log(error) }
        })
    }

    useEffect(() => { 
        initToken()
        getEstiData()
    },[])

    useEffect(() => { 
        // 로그인이 되어있고, 보호된 페이지로 이동하려고 할 때, intervalRef 설정. accessToken이 없으면 로그인 페이지로 리다이렉트
        if(accessToken && isProtectedRoute) {
            if (!intervalRef.current) { 
                intervalRef.current = window.setInterval(initToken, InitIntervalTime) 
            }
        }
        
        return () => { if (intervalRef.current && !isProtectedRoute) { 
            clearInterval(intervalRef.current)
            intervalRef.current = undefined
         } }
    }, [accessToken, curLocation.pathname])

    useEffect(()=>{
        // 로그인이 되어있고, 데이터가 다를때만 업데이트 됨
        if(accessToken) { 
            if(!getDataIntervalRef.current) { 
                getDataIntervalRef.current = window.setInterval(getEstiData, getDataIntervalTime) 
            }
        }

        return () => { if(getDataIntervalRef.current) { 
            clearInterval(getDataIntervalRef.current)
            getDataIntervalRef.current = undefined
         } }
    },[accessToken, estimateList])

    const MainContent = () => {
        return (
            <div className="wrap">
                <Sidebar/>
                {/** Body Content */}
                {isLoading && <div className="loading">
                    <p>Loading...</p>
                </div>}
                <Routes>
                    <Route path="/main" element={<MainPage/>} />
                    <Route path="/note" element={<NotePage/>} />
                    <Route path="/customer" element={<CustomerPage/>} />
                    <Route path="/setting" element={<SettingPage/>} />
                    <Route path="/insurance" element={<InsurancePage/>} />
                    <Route path="*" element={<Navigate to="/main" />} />
                </Routes>
            </div>
        )
    }

    return (
        <>
        {getRefreshToken() ? (
        <div id="main_contents">
            <Header/>
            <MainContent/>
        </div>)
        : 
        <Routes>
            {/** Introduce 페이지 디자인 완료시 '/'로 변경 */}
            <Route path="/intro" element={<IntroducePage/>} />
            <Route path="/login" element={<LoginPage/>} />
            <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
        }</>
    )
}

export default RouterPage
